<template>
  <div class="m-page">
    <div class="entrance-banner">
      <img src="../../../public/images/banner.jpg" class="m-img">
      <div @click="$router.push({name:'introduce'})" v-if="showIndividuationOpt">了解检前问诊 <span class="icon icon-arrow-right"></span></div>
      <div class="theNumber"> 平台已累计问诊 <span>{{theNumber['1']}} </span> 人次</div>
    </div>
    <div class="m-btn-box">
      <button v-if="showIndividuationOpt" class="btn m-btn"
              @click="individualization()"  >开始问诊&定制方案
      </button>
      <p class="m-text">其他体检方式</p>
    </div>
    <Item @click.native="select1XProduct" v-if="show1X">
      <slot slot="item-left">
        <img :src="getImageData('/wx/img/icon-package.png')" alt="">
      </slot>
      <slot slot="item-content">
        <h3>1 + X专项筛查套餐</h3>
        <p>针对常见疾病设置的专项早期筛查套餐</p>
      </slot>
      <slot slot="item-right">
        <i class="icon icon-arrow-right stable"></i>
      </slot>
    </Item>
    <Item @click.native="selectProduct">
      <slot slot="item-left">
<!--        <img :src="getImageData('/wx/img/icon-package.png')" alt="">-->
        <img src="../../../public/images/tijian_01.png" alt="">
      </slot>
      <slot slot="item-content">
        <h3>常规体检套餐 <div class="theNumber"> 已约 <span>{{theNumber['2']}} </span> 人次</div></h3>
        <p>按性别、年龄等基本信息快速查找常规体检套餐</p>
      </slot>
      <slot slot="item-right">
        <i class="icon icon-arrow-right stable"></i>
      </slot>
    </Item>
    <Item @click.native="selectCustom" v-if="showProjectSelectOpt">
      <slot slot="item-left">
<!--        <img :src="getImageData('/wx/img/icon-custom.png')" alt="">-->
        <img src="../../../public/images/tijian_02.png" alt="">
      </slot>
      <slot slot="item-content">
        <h3>自选体检项目 <div class="theNumber"> 已约 <span>{{theNumber['3']}} </span> 人次</div></h3>
        <p>了解自身体检需求，能自主选择体检项目，请点击进入</p>
      </slot>
      <slot slot="item-right">
        <i class="icon icon-arrow-right stable"></i>
      </slot>
    </Item>
    <hint :showModal="hintShow" showTxt="当前处于新型冠状病毒肺炎特殊阶段，为保证您和他人的健康和安全，请先完成“新型冠状病毒流行病学史问卷调查”，再做下一步的体检预约！" :btnList="['在线评估']" @btnClick="hintMsg"></hint>
    <hint :showModal="hintShow007" showTxt="非常报歉根据问卷结果，您暂时无法预约体检。如有疑问请拨打中心电话咨询：<a class='positive' href='tel:025-68303350'>025-68303350</ a>"  :btnList="[]" ></hint>
  </div>
</template>

<script>
import { Item, sysCenterList, hint } from '@/components/common'
import { mapState } from 'vuex'
import { Loading, isiOS } from '@/assets/scripts/helper'
import { IsWechat } from '@/assets/scripts/wechat/index'
import { BEFORE_QUESTION, BASE_PROJECT_LIST, GET_USER } from '@/assets/scripts/api'
import GEOLOCAION from '@/assets/scripts/geolocaion/index'
import Dict from '@/assets/scripts/dict/dict'

export default {
  components: {Item, sysCenterList, hint},
  data () {
    return {
      hintShow007: false,
      hintShow: false,
      sysCenterIdBy1X: '00-16',
      theNumber: {}
    }
  },
  async created () {
    Loading.show()
    if (!this.sysCenter || !this.sysCenter.cityId) {
      this.getGeolocain()
    }
    if (!this.$route.query.survey) {
      if (this.$route.query.source !== 'quickAppointment') {
        this.$store.commit('user/setFillUserInfo', {})
      }
      let {data} = await this.$axios.get('/1/xnhealthtool/xnhealthtool.json?_BIZCODE=0081&sysCenterId=' + this.sid)
        console.log(data)
      this.theNumber = data
      if (this.$route.query.sysCenterId) {
        Loading.show()
        await this.$store.dispatch('center/loadSysCenterDetail', this.$route.query.sysCenterId)
        Loading.close()
      } else if (this.sid === '00-0') {
        this.$store.commit('center/setSysCenter', {})
      }
    } else {


      if(this.$route.query.sid === '00-7' ) {
        let { data } = await this.$axios.get(GET_USER)
        if( data.data && data.data.isGzbd === '1'){
          this.hintShow007 = true
        }else {
          this.hintShow = true
        }
      }else {
        this.hintShow = true
      }
      //this.$router.replace({name: 'diseaseIndex', query:{id: '24', source: '1'}})
    }

    Loading.close()
  },
  computed: {
    ...mapState('center', {
      cityList: state => state.cityList || [],
      cityId: state => (state.sysCenter && state.sysCenter.cityId) || '',
      sysCenter: state => state.sysCenter
    }),

    ...mapState({
      sid: state => state.sid
    }),
    fillUserInfo () {
      return this.$store.state.user.fillUserInfo
    },
    show1X () {
      return this.sid === this.sysCenterIdBy1X || this.$store.state.center.sysCenter.id === this.sysCenterIdBy1X
    },
    showIndividuationOpt () {
      return (this.sid && this.$store.state.center.sysCenter.individuationOpt === 1) || this.sid === '00-0'
    },
    showProjectSelectOpt () {
      return (this.sid && this.$store.state.center.sysCenter.projectSelectOpt === 1) || this.sid === '00-0'
    }
  },
  methods: {
    async toCustomAppointmentConfirm () {
      Loading.show()
      let params = {
        sexCode: this.fillUserInfo.sexCode,
        marryStateCode: this.fillUserInfo.marryStateCode,
        age: this.fillUserInfo.age,
        sysCenterId: this.$route.query.sysCenterId
      }
      await this.$store.dispatch('project/loadProjectData', Object.assign({aqInstanceId: ''}, params))
      let {data} = await this.$axios.get(BASE_PROJECT_LIST(params))

      let basePackagePros = data.map(project => {
        project.projectId = project.id
        return project
      })

      this.$store.commit('project/initCustomizeProjectList', {
        basePackagePros,
        rulePackagePros: [],
        recommendPros: []
      })
      await this.$store.dispatch('project/loadProjectTree')
      await this.$store.commit('project/initProjectClassList')
      await this.$store.commit('project/setCheckedMaterialProjectList')
      this.$router.push({
        name: 'appointmentConfirm',
        params: {type: 'custom', id: 'custom'}
      })
      Loading.close()
    },
    async fromPersonal () {
      Loading.show()
      let data = null
      data = await this.beforeQuestion()
      let urlMsg = {}
      if (data !== null) {
        urlMsg = {
          name: 'questionDetails',
          params: {source: 'information', instanceId: data.instance.id}
        }
      } else {
        urlMsg = {name: 'physicalQuestionnaire', params: {source: 'personal'}}
      }
      this.$router.push(urlMsg)
      Loading.close()
    },
    async beforeQuestion () {
      let {data} = await this.$axios.get(BEFORE_QUESTION, {
        params: {
          type: 'x',
          marriageCode: this.fillUserInfo.marryStateCode,
          name: this.fillUserInfo.callName,
          sexCode: this.fillUserInfo.sexCode
        }
      })
      return data.data
    },
    async individualization () {
      await this.next()
      if (this.$route.query.source === 'quickAppointment') {
        await this.fromPersonal()
      } else { this.$router.push({name: 'registerInfo', params: {source: 'personal'}}) }
    },
    hintMsg () {
      if(this.$route.query.sid === '00-7'){
        this.$router.replace({name: 'diseaseIndex', query: {id: '00-7', source: '1'}})
      }else
      this.$router.replace({name: 'diseaseIndex', query: {id: '24', source: '1'}})
    },
    next () {
      let id = this.$route.query.id || ''
      this.$store.commit('setQuickAppointment', id)
    },
    getGeolocain () {
      GEOLOCAION().then(data => {
        this.cityList.forEach(obj => {
          let {name, id} = obj
          if (data.city.indexOf(name) !== -1 || data.city.indexOf(name.substring(0, name.length - 1)) !== -1) {
            this.$store.commit('center/setPosition', obj)
          }
        })
      })
    },
    async  selectCustom () {
      this.$store.commit('project/clearProjectData')
      await this.next()
      if (this.$route.query.source === 'quickAppointment') { await this.toCustomAppointmentConfirm() } else { this.$router.push({name: 'registerInfo', params: {source: 'custom'}}) }
    },
    async  select1XProduct () {
      //      if(this.$route.query.source === 'quickAppointment'){
      await this.next()
      //      }
      this.$router.push({name: 'productList', query: {typeId: '0114a438-34ed-4c44-9a8d-eadb6ad263ca'}})
    },
    getImageData (url) {
      let uri = this.$store.state.imageResourcesUrl + url
      return uri
    },
    async selectProduct () {
      await this.next()
      if (this.$route.query.source === 'quickAppointment') { this.$router.push({name: 'productList', query: {sysCenterId: this.$route.query.sysCenterId, sexId: (Dict.check_object.find(obj => { return obj.code === this.fillUserInfo.sexCode })).id }}) } else { this.$router.push({name: 'productList'}) }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";
  .m-page{
    width: 10rem;
    overflow-x: hidden;
  }
.m-img {
  width: 100%;
  vertical-align: middle;
}

.entrance-banner{
  position: relative;
  div{
    position: absolute;
    bottom: 75px;
    text-align: center;
    width: 100%;
    font-size: 16px;
    color: $light;
  }
  .theNumber{
    font-size: 12px;
    bottom: 5px;
    right:-100px;
    span{
      font-weight: bold;
    }
  }
}

.m-btn-box {
  width: 100%;
  text-align: center;
  background-color: rgb(240, 239, 244);
  .m-btn {
    width: 80%;
    height: 50px;
    line-height: 50px;
    margin-top: 40px;
    font-size: 20px;
    background-color: $assertive;
    color: #ffffff;
  }
  .m-text {
    padding: 20px 15px;
    font-size: 14px;
    text-align: left;
  }
}

.item /deep/ {
  img {
    width: 80px;
  }
  p {
    padding-top: 5px;
  }
  .theNumber{
    color: $assertive;
    font-size: 12px;
    position:absolute;
    right: 15px;
    top:21px;
    span{
      font-weight: bold;
    }
  }
}

</style>
